// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.proskins-section-title.tier_a-text {
  color: var(--tier-a);
}

.proskins-section-title.tier_b-text {
  color: var(--tier-b);
}

.proskins-section-title.tier_c-text {
  color: var(--tier-c);
}

.proskins-section-title.tier_d-text {
  color: var(--tier-d);
}

.golfers-cards {
  display: flex;
  flex-wrap: wrap;
}

.golfers-cards .card-content {
  padding: 0;
}

.golfers-card .card {
  padding: var(--spacing-xs);
}

.golfers-proskins-main .golfers-card {
  width: 25%;
  padding: var(--spacing-xs);
}

.golfers-card .proskins-table th {
  font-size: var(--font-size-xs);
}

.golfers-card .proskins-table th,
.golfers-card .proskins-table td {
  padding: 0.3rem;
}

.golfers-card .proskins-section-title {
  margin-bottom: var(--spacing-sm);
}

.proskins-table {
  border-radius: 0 !important;
}

/* Card vertical scroller start */
.proskins-table {
  border: 1px solid #333;
  max-height: 430px;
}

/* Make body scrollable */
.proskins-table-body {
  max-height: 380px; /* adjust depending on header height */
  overflow-y: auto;

  /* Smooth scrolling for mobile */
  -webkit-overflow-scrolling: touch;
}

/* Consistent table styling */
.proskins-table-head table,
.proskins-table-body table {
  border-collapse: collapse;
  width: 100%;
}

.proskins-table-head th,
.proskins-table-body td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #444;
}

/* Webkit browsers (Chrome, Safari, Edge) */
.proskins-table-body::-webkit-scrollbar {
  width: 4px; /* vertical scrollbar width */
}

.proskins-table-body::-webkit-scrollbar-track {
  background: transparent;
}

.proskins-table-body::-webkit-scrollbar-thumb {
  background-color: rgba(125, 125, 125, 0.4);
  border-radius: 3px;
}

.proskins-table-body::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.6);
}
/* Card vertical scroller end */

@media (max-width: 1200px) {
  .golfers-proskins-main .golfers-card {
    width: 50%;
    margin-bottom: var(--spacing-xl);
  }
}
@media (max-width: 640px) {
  .golfers-proskins-main .golfers-card {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Golfers.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB,EAAE,sCAAsC;EACzD,gBAAgB;;EAEhB,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA,6BAA6B;AAC7B;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,2CAA2C;AAC3C;EACE,UAAU,EAAE,6BAA6B;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;AACA,+BAA+B;;AAE/B;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;AACA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".proskins-section-title.tier_a-text {\n  color: var(--tier-a);\n}\n\n.proskins-section-title.tier_b-text {\n  color: var(--tier-b);\n}\n\n.proskins-section-title.tier_c-text {\n  color: var(--tier-c);\n}\n\n.proskins-section-title.tier_d-text {\n  color: var(--tier-d);\n}\n\n.golfers-cards {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.golfers-cards .card-content {\n  padding: 0;\n}\n\n.golfers-card .card {\n  padding: var(--spacing-xs);\n}\n\n.golfers-proskins-main .golfers-card {\n  width: 25%;\n  padding: var(--spacing-xs);\n}\n\n.golfers-card .proskins-table th {\n  font-size: var(--font-size-xs);\n}\n\n.golfers-card .proskins-table th,\n.golfers-card .proskins-table td {\n  padding: 0.3rem;\n}\n\n.golfers-card .proskins-section-title {\n  margin-bottom: var(--spacing-sm);\n}\n\n.proskins-table {\n  border-radius: 0 !important;\n}\n\n/* Card vertical scroller start */\n.proskins-table {\n  border: 1px solid #333;\n  max-height: 430px;\n}\n\n/* Make body scrollable */\n.proskins-table-body {\n  max-height: 380px; /* adjust depending on header height */\n  overflow-y: auto;\n\n  /* Smooth scrolling for mobile */\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Consistent table styling */\n.proskins-table-head table,\n.proskins-table-body table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.proskins-table-head th,\n.proskins-table-body td {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #444;\n}\n\n/* Webkit browsers (Chrome, Safari, Edge) */\n.proskins-table-body::-webkit-scrollbar {\n  width: 4px; /* vertical scrollbar width */\n}\n\n.proskins-table-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.proskins-table-body::-webkit-scrollbar-thumb {\n  background-color: rgba(125, 125, 125, 0.4);\n  border-radius: 3px;\n}\n\n.proskins-table-body::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(255, 255, 255, 0.6);\n}\n/* Card vertical scroller end */\n\n@media (max-width: 1200px) {\n  .golfers-proskins-main .golfers-card {\n    width: 50%;\n    margin-bottom: var(--spacing-xl);\n  }\n}\n@media (max-width: 640px) {\n  .golfers-proskins-main .golfers-card {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
